import React from 'react';
import { Box, Typography } from '@mui/material';

const ParticipantCard = ({ 
  title, 
  icon, 
  participants, 
  color = '#2DB400',
  emptyMessage = '참석자 없음'
}) => {
  return (
    <Box sx={{ mb: 2 }}>
      <Typography
        sx={{
          fontWeight: 'bold',
          color: color,
          fontSize: '0.9rem',
          mb: 1,
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
        }}
      >
        {icon} {title}
      </Typography>
      <Box
        sx={{
          backgroundColor: '#f8f9fa',
          p: 1,
          borderRadius: '8px',
          border: '1px solid #e9ecef',
          minHeight: '40px',
        }}
      >
        <Typography sx={{ color: '#495057', lineHeight: 1.6 }}>
          {participants || emptyMessage}
        </Typography>
      </Box>
    </Box>
  );
};

export default ParticipantCard;
